// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"cfc6a373","609":"49ee851d"}[chunkId] + ".css";
};